import {
  PERFORMANCEAPPRAISAL_LOADING,
  GET_PERFORMANCEAPPRAISAL,
  GET_PERFORMANCEAPPRAISAL_SUCCESS,
  GET_PERFORMANCEAPPRAISAL_FAIL,
  ADD_PERFORMANCEAPPRAISAL_SUCCESS,
  ADD_PERFORMANCEAPPRAISAL_FAIL,
  DELETE_PERFORMANCEAPPRAISAL_SUCCESS,
  DELETE_PERFORMANCEAPPRAISAL_FAIL,
  UPDATE_PERFORMANCEAPPRAISAL_SUCCESS,
  UPDATE_PERFORMANCEAPPRAISAL_FAIL,
  PERFORMANCEAPPRAISAL_RESET
} from "./actionType";

const INIT_STATE = {
  performanceAppraisals: [],
  error: {},
};

const PerformanceAppraisal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERFORMANCEAPPRAISAL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PERFORMANCEAPPRAISAL:
          return {
            ...state,
            performanceAppraisals: action.payload.data,
            isPerformanceAppraisalCreated: false,
            isPerformanceAppraisalSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PERFORMANCEAPPRAISAL_FAIL:
      switch (action.payload.actionType) {
        case GET_PERFORMANCEAPPRAISAL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPerformanceAppraisalCreated: false,
            isPerformanceAppraisalSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PERFORMANCEAPPRAISAL: {
      return {
        ...state,
        isPerformanceAppraisalCreated: false,
        loading: true,
      };
    }

    case PERFORMANCEAPPRAISAL_LOADING: {
      return {
        ...state,
        isPerformanceAppraisalCreated: false,
        loading: true,
      };
    }

    case ADD_PERFORMANCEAPPRAISAL_SUCCESS:
      return {
        ...state,
        isPerformanceAppraisalCreated: true,
        loading: false,
        performanceAppraisals: [action.payload.data, ...state.performanceAppraisals],
      };

    case ADD_PERFORMANCEAPPRAISAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PERFORMANCEAPPRAISAL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceAppraisalCreated: true,
        performanceAppraisals: state.performanceAppraisals.filter(
          performanceAppraisal => performanceAppraisal.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PERFORMANCEAPPRAISAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PERFORMANCEAPPRAISAL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformanceAppraisalCreated: true,
        performanceAppraisals: state.performanceAppraisals.map(performanceAppraisal =>
          performanceAppraisal.id.toString() === action.payload.data.id.toString() ? { ...performanceAppraisal, ...action.payload.data } : performanceAppraisal
        ),
      };

    case UPDATE_PERFORMANCEAPPRAISAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PERFORMANCEAPPRAISAL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PerformanceAppraisal;